import { api } from './api';
import {
  WebhookSummaryResponse,
  WebhookPaginatedResponse,
  WebhookUnifiedEvent,
  WebhookStripeEvent,
  WebhookStripeParams,
  WebhookCheckrEvent,
  WebhookCheckrParams,
  WebhookBookingEvent,
  WebhookBookingParams,
  WebhookVideoEvent,
  WebhookGroupSessionEvent,
  WebhookSessionMonitoring,
  WebhookSessionParams,
  WebhookSafetyFlag,
  WebhookSafetyParams,
  WebhookReferralEvent,
  WebhookReferralParams,
  WebhookFraudSignal,
  WebhookFraudParams,
  WebhookCallLog,
  WebhookCallLogParams,
  WebhookAnalyticsEvent,
  WebhookAnalyticsParams,
  WebhookAuditLog,
  WebhookAuditParams,
  WebhookUploadEvent,
  WebhookUploadParams,
  WebhookBaseParams,
} from '../types/webhook';

const BASE_PATH = '/admin/webhooks';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const cleanQueryParams = (params: any): Record<string, string | number | boolean> => {
  const clean: Record<string, string | number | boolean> = {};
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== '') {
      clean[key] = value as string | number | boolean;
    }
  }
  return clean;
};

export const getSummary = async (): Promise<WebhookSummaryResponse> => {
  const response = await api.get(`${BASE_PATH}/summary`);
  return response.data;
};

export const getUnifiedEvents = async (
  params: WebhookBaseParams = {}
): Promise<WebhookPaginatedResponse<WebhookUnifiedEvent>> => {
  const response = await api.get(BASE_PATH, { params: cleanQueryParams(params) });
  return response.data;
};

export const getStripeEvents = async (
  params: WebhookStripeParams = {}
): Promise<WebhookPaginatedResponse<WebhookStripeEvent>> => {
  const response = await api.get(`${BASE_PATH}/stripe`, { params: cleanQueryParams(params) });
  return response.data;
};

export const getCheckrEvents = async (
  params: WebhookCheckrParams = {}
): Promise<WebhookPaginatedResponse<WebhookCheckrEvent>> => {
  const response = await api.get(`${BASE_PATH}/checkr`, { params: cleanQueryParams(params) });
  return response.data;
};

export const getBookingEvents = async (
  params: WebhookBookingParams = {}
): Promise<WebhookPaginatedResponse<WebhookBookingEvent>> => {
  const response = await api.get(`${BASE_PATH}/booking-events`, { params: cleanQueryParams(params) });
  return response.data;
};

export const getVideoEvents = async (
  params: WebhookSessionParams = {}
): Promise<WebhookPaginatedResponse<WebhookVideoEvent>> => {
  const response = await api.get(`${BASE_PATH}/video-events`, { params: cleanQueryParams(params) });
  return response.data;
};

export const getGroupSessionEvents = async (
  params: WebhookSessionParams = {}
): Promise<WebhookPaginatedResponse<WebhookGroupSessionEvent>> => {
  const response = await api.get(`${BASE_PATH}/group-session-events`, { params: cleanQueryParams(params) });
  return response.data;
};

export const getSessionMonitoring = async (
  params: WebhookSessionParams = {}
): Promise<WebhookPaginatedResponse<WebhookSessionMonitoring>> => {
  const response = await api.get(`${BASE_PATH}/session-monitoring`, { params: cleanQueryParams(params) });
  return response.data;
};

export const getSafetyFlags = async (
  params: WebhookSafetyParams = {}
): Promise<WebhookPaginatedResponse<WebhookSafetyFlag>> => {
  const response = await api.get(`${BASE_PATH}/safety-flags`, { params: cleanQueryParams(params) });
  return response.data;
};

export const getReferralEvents = async (
  params: WebhookReferralParams = {}
): Promise<WebhookPaginatedResponse<WebhookReferralEvent>> => {
  const response = await api.get(`${BASE_PATH}/referral-events`, { params: cleanQueryParams(params) });
  return response.data;
};

export const getFraudSignals = async (
  params: WebhookFraudParams = {}
): Promise<WebhookPaginatedResponse<WebhookFraudSignal>> => {
  const response = await api.get(`${BASE_PATH}/fraud-signals`, { params: cleanQueryParams(params) });
  return response.data;
};

export const getCallLogs = async (
  params: WebhookCallLogParams = {}
): Promise<WebhookPaginatedResponse<WebhookCallLog>> => {
  const response = await api.get(`${BASE_PATH}/call-logs`, { params: cleanQueryParams(params) });
  return response.data;
};

export const getAnalyticsEvents = async (
  params: WebhookAnalyticsParams = {}
): Promise<WebhookPaginatedResponse<WebhookAnalyticsEvent>> => {
  const response = await api.get(`${BASE_PATH}/analytics-events`, { params: cleanQueryParams(params) });
  return response.data;
};

export const getAuditLogs = async (
  params: WebhookAuditParams = {}
): Promise<WebhookPaginatedResponse<WebhookAuditLog>> => {
  const response = await api.get(`${BASE_PATH}/audit-logs`, { params: cleanQueryParams(params) });
  return response.data;
};

export const getUploadEvents = async (
  params: WebhookUploadParams = {}
): Promise<WebhookPaginatedResponse<WebhookUploadEvent>> => {
  const response = await api.get(`${BASE_PATH}/upload-events`, { params: cleanQueryParams(params) });
  return response.data;
};

export const webhookService = {
  getSummary,
  getUnifiedEvents,
  getStripeEvents,
  getCheckrEvents,
  getBookingEvents,
  getVideoEvents,
  getGroupSessionEvents,
  getSessionMonitoring,
  getSafetyFlags,
  getReferralEvents,
  getFraudSignals,
  getCallLogs,
  getAnalyticsEvents,
  getAuditLogs,
  getUploadEvents,
};

export default webhookService;
